export default function createSSCLocale(locale: Record<string, string>) {
  const paginationPageSize = locale['pagination.pageSizeSelection']
    .replace('{pageSize}', '')
    .trim();

  return {
    ssc: {
      colorpicker: {
        confirm: locale['common.confirmButton'],
        clear: locale['menu.clearSearchHistoryButton'],
      },
      datepicker: {
        now: locale['picker.now'],
        cancel: locale['common.cancelButton'],
        clear: locale['menu.clearSearchHistoryButton'],
        reset: locale['common.resetButton'],
        confirm: locale['common.confirmButton'],
        selectDate: locale['picker.placeholder'],
        selectTime: locale['picker.selectTime'],
        startDate: locale['picker.startDate'],
        startTime: locale['picker.timeRangeStartTitle'],
        endDate: locale['picker.endDate'],
        endTime: locale['picker.timeRangeEndTitle'],
        month1: locale['calendar.january'],
        month2: locale['calendar.february'],
        month3: locale['calendar.march'],
        month4: locale['calendar.april'],
        month5: locale['calendar.may'],
        month6: locale['calendar.june'],
        month7: locale['calendar.july'],
        month8: locale['calendar.august'],
        month9: locale['calendar.september'],
        month10: locale['calendar.october'],
        month11: locale['calendar.november'],
        month12: locale['calendar.december'],
        weeks: {
          sun: locale['calendar.sundayShort'],
          mon: locale['calendar.mondayShort'],
          tue: locale['calendar.tuesdayShort'],
          wed: locale['calendar.wednesdayShort'],
          thu: locale['calendar.thursdayShort'],
          fri: locale['calendar.fridayShort'],
          sat: locale['calendar.saturdayShort'],
        },
        months: {
          jan: locale['calendar.januaryShort'],
          feb: locale['calendar.februaryShort'],
          mar: locale['calendar.marchShort'],
          apr: locale['calendar.aprilShort'],
          may: locale['calendar.mayShort'],
          jun: locale['calendar.juneShort'],
          jul: locale['calendar.julyShort'],
          aug: locale['calendar.augustShort'],
          sep: locale['calendar.septemberShort'],
          oct: locale['calendar.octoberShort'],
          nov: locale['calendar.novemberShort'],
          dec: locale['calendar.decemberShort'],
        },
      },
      select: {
        loading: locale['common.loading'],
        noMatch: locale['select.noResults'],
        noData: locale['table.noData'],
        placeholder: locale['select.placeholder'],
        confirm: locale['common.confirmButton'],
        reset: locale['common.resetButton'],
        buttonText: locale['proTableSeries.addItemButton'],
        search: locale['select.search'],
      },
      slider: {
        confirm: locale['common.confirmButton'],
        reset: locale['common.resetButton'],
      },
      cascader: {
        noMatch: locale['select.noResults'],
        loading: locale['common.loading'],
        placeholder: locale['select.placeholder'],
        noData: locale['table.noData'],
        confirm: locale['common.confirmButton'],
        reset: locale['common.resetButton'],
      },
      pagination: {
        go: locale['pagination.goToPageButton'],
        goto: locale['pagination.goToPageText'],
        pagesize: paginationPageSize,
        total: locale['pagination.totalSimple'],
      },
      messagebox: {
        title: locale['rangeInput.noticeModal.title'],
        confirm: locale['common.confirmButton'],
        cancel: locale['common.cancelButton'],
      },
      upload: {
        dragNotice: locale['upload.dropHereOr'],
        selectFiles: locale['upload.selectFilesButton'],
        uploadFailed: locale['common.loadFailed'],
        waiting: locale['common.loading'],
      },
      table: {
        emptyText: locale['table.noData'],
        confirmFilter: locale['common.confirmButton'],
        resetFilter: locale['common.resetButton'],
        clearFilter: locale['table.filterSelectAll'],
        moreColumns: locale['form.more'],
        selectAll: locale['common.selectAll'],
        confirm: locale['common.confirmButton'],
        optionalHeaderEmptyText: locale['table.noData'],
        search: locale['form.search'],
      },
      tree: {
        emptyText: locale['table.noData'],
      },
      image: {
        error: locale['common.loadFailed'],
      },
      input: {
        placeholder: locale['input.placeholder'],
      },
      pageHeader: {
        title: locale['form.previous'],
      },
      popconfirm: {
        confirmButtonText: locale['common.confirmButton'],
        cancelButtonText: locale['common.cancelButton'],
      },
      inputCascader: {
        placeholder: locale['select.placeholder'],
      },
      switch: {
        on: locale['switch.onText'],
        off: locale['switch.offText'],
      },
    },
  };
}
